export default __webpack_public_path__ + "static/media/typeBicycle.6f7881ed.6f7881ed.svg";